module.exports = __webpack_public_path__ + "img/icone-baixar.32dac5e0.svg";